module.exports = __webpack_public_path__ + "static/alertExample2-73a5401001e068f35c0944cd96b57032.png";